import Group from '../models/Group';
import GroupAccessReview from '../models/GroupAccessReview';
import { IGroupsService } from './IGroupsService';

// This is a stub implementation of the GroupsService
// that returns test groups from the PROD tenant, regardless of the environment the app is running in.
export default class StubGroupsService implements IGroupsService{
	static readonly testGroups: Group[] = [
		{
			createdDateTime: '2026-03-12T13:45:09+00:00',
			displayName: 'SSP_AWS_TEST_1',
			description: 'Group for testing AWS Accounts Integration from the SSP',
			mailEnabled: false,
			mailNickName: 'SSP_AWS_TEST_1',
			securityEnabled: true,
			groupTypes: [],
			id: '70bf5df3-034e-4749-a9aa-8947b31fb242',
		},
		{
			createdDateTime: '2026-03-12T13:45:41+00:00',
			displayName: 'SSP_AWS_TEST_2',
			description: 'Group for testing AWS Accounts Integration from the SSP',
			mailEnabled: false,
			mailNickName: 'SSP_AWS_TEST_2',
			securityEnabled: true,
			groupTypes: [],
			id: '9790e9b5-e2d5-404c-b86c-54a19c32cb5a',
		},
		{
			createdDateTime: '2026-03-12T13:45:55+00:00',
			displayName: 'SSP_AWS_TEST_3.PIM',
			description: 'Group for testing AWS Accounts Integration from the SSP',
			mailEnabled: false,
			mailNickName: 'SSP_AWS_TEST_3.PIM',
			securityEnabled: true,
			groupTypes: [],
			id: '13cc828f-c0f8-4913-b5a5-c6c20f3f4fc4',
		},
		{
			createdDateTime: '2026-03-12T13:46:07+00:00',
			displayName: 'SSP_AWS_TEST_4.PIM',
			description: 'Group for testing AWS Accounts Integration from the SSP',
			mailEnabled: false,
			mailNickName: 'SSP_AWS_TEST_4.PIM',
			securityEnabled: true,
			groupTypes: [],
			id: 'df08869e-4ed4-44fb-b04a-ddd8a5a348f3',
		},
	].map((g) => new Group(g));

	async getMyGroups() {
		return StubGroupsService.testGroups;
	}

	private placeholderGroup = (id: string) => new Group({
			createdDateTime: '2026-03-12T13:46:07+00:00',
			displayName: id,
			description: 'Placeholder Group',
			mailEnabled: false,
			mailNickName: id,
			securityEnabled: true,
			groupTypes: [],
			id,
	})

	async getById(id: string) {
		return StubGroupsService.testGroups.find((group) => group.id === id) 
			?? this.placeholderGroup(id);
	}

	async createGroup(displayName: string, description: string, membershipRule: string) {
		return Promise.resolve(null);
	}

	async updateGroup(id: string, membershipRule: string) {
		return Promise.resolve(null);
	}

	async groupLookup(name: string) {
		return StubGroupsService.testGroups.filter((group) => group.displayName.toLowerCase().includes(name.toLowerCase()));
	}

	async createGroupAccessReview(id: string, model: GroupAccessReview) {
		return Promise.resolve(null);
	}
}
